// extracted by mini-css-extract-plugin
module.exports = {"cont":"BizPeriodPicker_cont__10lDd","label":"BizPeriodPicker_label__vqZ7k","picker":"BizPeriodPicker_picker__-h2vo"};